import { getAxiosClient } from "../../HttpsService";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Process } from "./processes-interface";

export const fetchProcesses = createAsyncThunk(
  "processes/fetchProcesses",
  async (appUuid: string) => {
    const client = getAxiosClient();
    const response = await client.get(
      `api/eza_app_process/app-uuid/${appUuid}`
    );
    return response.data as Process[];
  }
);

export const fetchProcessByUuid = createAsyncThunk(
  "processes/fetchProcessByUuid",
  async (processUuid: string) => {
    const client = getAxiosClient();
    const response = await client.get(
      `api/eza_app_process/uuid/${processUuid}`
    );
    return response.data as Process;
  }
);

export const fetchAllProcesses = createAsyncThunk(
  "processes/fetchAllProcesses",
  async () => {
    const client = getAxiosClient();
    const response = await client.get(`api/eza_app_process`);
    return response.data as Process[];
  }
);
